export const productInfo = {
    invoiceNumber : 2341312,
    discount : 30,
    info : [
        {
            id: 1,
            description : 'Logo Design',
            price : 440,
            qty : 2,
        },
        {
            id: 2,
            description : 'Web Site Design',
            price : 120,
            qty : 4,
        },
        {
            id: 3,
            description : 'Logo Design',
            price : 300,
            qty : 1,
        },
        {
            id: 4,
            description : 'Web Site Design',
            price : 122,
            qty : 4,
        },
        {
            id: 5,
            description : 'XD',
            price : 399,
            qty : 8,
        },
    ] 
}
export const location = [
    '#Main Road',
    '#Building Name',
    '#Country',
]
export const companyConnections = {
    connection : {
        address : 'your street addres here',
        number : '000 000 000',
        email : 'www.ClothingCo.com',
    }
}
export const customerInfo = {
    info :{
        name : '#Customer Name',
        address : '24 Dummy Street Area,',
        location : 'Lorem Ipsum,'
    }
}
export const companyInfo = {
    info :{
        managerName : '#Manager Name',
        customerName : '#Customer Name',
        productName : '#Product Name',
    }
}
export const paymentInfo=[
    {
        label : 'Account',
        value : '#000 0000 000',
    },
    {
        label : 'A/C NAME',
        value : '#000 0000 000',
    },
    {
        label : 'BANK DETAILS',
        value : '#Your Account',
    }, 
]